import showToast from "../../Hooks/toast";

const { useDispatch, useSelector } = require("react-redux");

const useLineItemsCheck = () => {
  const dispatch = useDispatch();
  const line_items = useSelector(
    (state) => state.rootReducer.scheduleSlice.line_items
  );

  const check = () => {
    const checked = line_items?.filter(
      (item) => item?.type_of_service?.is_main
    );
    if (checked.length > 0) {
      return true;
    } else {
      showToast(
        "You should have at least one main product or add 'Service' to able create the job",
        "error"
      );
    }
  };

  return {
    check,
  };
};

export default useLineItemsCheck;
